import { createState, asNonNullSubscribable } from '../helpers/state-subject';
import { ensureGlobalState, logInstanceId } from '../helpers/state';
logInstanceId("cart.service");
const TIERED_PROGRESS_SECTION = 'tiered-progress-data';
function getTieredProgressSection() {
    return document.getElementById(TIERED_PROGRESS_SECTION) ? TIERED_PROGRESS_SECTION : undefined;
}
const SHARED_REQUEST_CONFIG = {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
};
export const cartState = ensureGlobalState("untuckit.cart", createState(null));
export const onCartUpdate = asNonNullSubscribable(cartState);
export async function updateCart(request) {
    const requestOptions = {
        ...SHARED_REQUEST_CONFIG,
        body: JSON.stringify(request)
    };
    const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, requestOptions);
    const json = await response.json();
    if (!response.ok) {
        logErrors("Error updating cart", json, response.headers, request);
        throw new Error();
    }
    return json;
}
export async function addToCart(request) {
    const requestOptions = {
        ...SHARED_REQUEST_CONFIG,
        body: JSON.stringify(request)
    };
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, requestOptions);
    const json = await response.json();
    if (!response.ok) {
        logErrors("Error adding item to cart", json, response.headers, request);
        throw new Error();
    }
    getCart();
    return json;
}
export async function getCart() {
    const section = getTieredProgressSection();
    const [cartResponse, sectionsResponse] = await Promise.all([
        fetch(`${window.Shopify.routes.root}cart.js`),
        section ? fetch(`${window.Shopify.routes.root}?sections=${section}`) : Promise.resolve(null)
    ]);
    const json = await cartResponse.json();
    if (!cartResponse.ok) {
        logErrors("Error fetching cart", json, cartResponse.headers, null);
        throw new Error();
    }
    json.items = json.items.filter(i => i.quantity > 0) || []; // shopify will sometimes return out of stock items with 0 quantity
    if (sectionsResponse?.ok) {
        json.sections = await sectionsResponse.json();
    }
    cartState.set(json);
    return json;
}
export class ChangeLineItemError extends Error {
    payload;
    constructor(message, payload) {
        super(message);
        this.name = "ChangeLineItemError";
        this.payload = payload;
    }
}
export async function changeLineItem(request) {
    const requestOptions = {
        ...SHARED_REQUEST_CONFIG,
        body: JSON.stringify(request)
    };
    const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, requestOptions);
    const json = await response.json();
    if (!response.ok) {
        logErrors("Error changing line item", json, response.headers, request);
        let reason = 'GENERIC';
        let passedthroughServerMessage = '';
        if (response.status === 422) {
            const lowercaseMessage = (json.message || '').toLowerCase();
            // not great, but shopify doesn't provide error codes
            if (lowercaseMessage.includes('sold out')) {
                reason = 'SOLD_OUT';
            }
            else if (lowercaseMessage.includes('due to availability')) {
                reason = 'CANNOT_ADD_INVENTORY';
                passedthroughServerMessage = json.message;
                getCart(); // refresh the cart to get the latest inventory data
            }
        }
        throw new ChangeLineItemError('', { reason, passedthroughServerMessage });
    }
    getCart();
    return json;
}
function getResponseError(json) {
    return json?.description || json?.message || 'unknown';
}
function logErrors(description, response, headers, requestPayload) {
    const responseError = getResponseError(response);
    console.error(`${description}:`, responseError);
    const requestId = headers.get('x-request-id');
    if (requestId) {
        console.error("cart request id", requestId, JSON.stringify(requestPayload));
    }
}
